module.exports = __webpack_public_path__ + "static/media/party-catering-hero.7b83bebc.jpg";